// Общие части двух витрин: шаги, гарантия, вопросы, призыв начать.
import type { ReactNode } from "react";
import type { Direction } from "../../api/types";
import { NEW_ORDER_PATH } from "../../site/directionPaths";
import type { FaqItem } from "../../site/faq";
import { Button } from "../../ui/Button";
import { Link } from "react-router";
import { Icon } from "../../ui/icons";
import { SloganLine } from "../../ui/Slogan";
import styles from "./Showcase.module.css";

export function ShowcaseSection({
  title,
  aside,
  children,
  id,
}: {
  title: string;
  aside?: ReactNode;
  children: ReactNode;
  id?: string;
}) {
  return (
    <section className={styles.section} id={id}>
      <div className={styles.sectionHeader}>
        <h2 className="h2">{title}</h2>
        {aside}
      </div>
      {children}
    </section>
  );
}

export function HowItWorks({ steps }: { steps: { title: string; text: string }[] }) {
  return (
    <ShowcaseSection title="Как это работает">
      <ol className={styles.steps}>
        {steps.map((step, index) => (
          <li key={step.title} className={styles.step}>
            <span className={styles.stepNumber}>{index + 1}</span>
            <span style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <span style={{ fontWeight: 600 }}>{step.title}</span>
              <span className="small muted">{step.text}</span>
            </span>
          </li>
        ))}
      </ol>
      <Link to="/how" className={styles.allSteps}>
        Все шаги подробно — от селфи до посылки
        <Icon name="arrow" size={16} strokeWidth={2.4} />
      </Link>
    </ShowcaseSection>
  );
}

export function Guarantee({ text }: { text: string }) {
  return (
    <section className={styles.section}>
      <div className={styles.guarantee}>
        <Icon name="shield" size={28} />
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <span className="h3">Гарантия возврата</span>
          <span className="small">{text}</span>
        </div>
      </div>
    </section>
  );
}

// Список вопросов: первый раскрыт. Его же показывает страница /faq.
export function FaqList({ items }: { items: FaqItem[] }) {
  return (
    <div>
      {items.map((item, index) => (
        <details key={item.question} className={styles.faq} open={index === 0}>
          <summary>
            {item.question}
            <Icon name="chevronDown" size={20} />
          </summary>
          <p>{item.answer}</p>
        </details>
      ))}
    </div>
  );
}

// Вопросы на витрине и под ними «Все вопросы» — на страницу /faq, раздел этого направления.
export function Questions({ items, allQuestionsPath }: { items: FaqItem[]; allQuestionsPath: string }) {
  return (
    <ShowcaseSection title="Вопросы" id="faq">
      <FaqList items={items} />
      <Link to={allQuestionsPath} className={styles.allQuestions}>
        Все вопросы
      </Link>
    </ShowcaseSection>
  );
}

export function StartButton({ direction }: { direction: Direction }) {
  return <Button to={NEW_ORDER_PATH[direction]}>Создать фигурку</Button>;
}

export function FinalCall({ direction, slogan }: { direction: Direction; slogan: string }) {
  return (
    <section className={styles.cta}>
      <SloganLine title={slogan} />
      <StartButton direction={direction} />
      <p className={`text small muted ${styles.centered}`}>Начни с селфи — это бесплатно</p>
    </section>
  );
}


